import React, { useEffect, useContext, useState } from 'react';
import { Router, Redirect, globalHistory, navigate, Location } from '@reach/router';
import DialogBox from '../../components/DialogBox';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useIntl } from 'react-intl';
import Cookies from 'js-cookie';
import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Drawer from '@material-ui/core/Drawer';
// import registerServiceWorker from '../../workboxServiceWorker';
import { Context } from '../../components/Multi-lang/Wrapper';
const { saveAddressToDefault, fetchAddress } = Slices.addressSlice;
import MultiCountryPopUp from '../../components/MultiCountryPopUp';
import SwipeableCountryDrawer from '../../components/CountryDrawer';
import Login from '../Login';
import Home from '../Home';
import Cart from '../Cart';
import FAQ from '../FAQ';
import Terms from '../Terms';
import AddEmail from '../AddEmail';
// import LocalChicken from '../LocalChicken';
import Offers from '../Offers';
import OrderHistoryList from '../OrderHistoryList';
import Feedback from '../Feedback';
import Checkout from '../Checkout';
import Category from '../Category';
import Product from '../Product';
import Deal from '../Deal';
import Profile from '../Profile';
import Payment from '../Payment';
import Pickup from '../Pickup';
import Guest from '../Guest';
import GuestOTP from '../GuestOTP';
import AddressList from '../AddressList';
import VerifyOTP from '../VerifyOTP';
import Thankyou from '../ThankYou';
import AddAddress from '../AddAddress';
import Search from '../Search';
import EditAddress from '../EditAddress';
import Carhop from '../Carhop';
import DineIn from '../DineIn';
import DriveThru from '../DriveThru';
import OrderDetail from '../OrderDetail';
import TrackOrderDetail from '../TrackOrderDetail';
import TrackOrder from '../TrackOrder';
import AddNumber from '../AddNumber';
import AddNumberVerifyOTP from '../AddNumberVerifyOTP';
import AboutPage from '../AboutPage';
const {
  fetchConfig,
  getHomeJsonComponents,
  selectCountryValidations,
  selectConfigStatus,
  selectOrderModesByCountry,
  getClusterId,
} = Slices.configSlice;
const { fetchMenu, selectMenuStatus } = Slices.menuSlice;
const { loginGuest, logout, setRefreshToken, selectLoginStatus } = Slices.authSlice;
import Logout from '../Logout';
import CreateProfile from '../CreateProfile';
import OfferApplied from '../OfferApplied';
import Customize from '../Customize';
const { getProfile, selectCurrentCountry, isMultiCountry, getCurrentProfile } = Slices.profileSlice;

const { getCountryPopState, saveActGreenValues, setResponsive } = Slices.appSlice;
import NutritionInfo from '../NutritionInfo';
import PrivacyPolicy from '../PrivacyPolicy';
import ContactUs from '../ContactUs';
import css from './index.module.scss';
import Addresses from '../AddressList/addresses';
import MySavedCards from '../Profile/MySavedCards';
import {
  deliveryModeGA,
  userIDGA,
  virtualPageGA,
  beforeInstallPromptPwaGA,
  installPwaGA,
} from 'spwa-ui-library/esm/utils/helperGA';
import { getDefaultCountryValues } from 'spwa-ui-library/esm/utils/helper';
import FeedbackInfo from '../Feedback/FeedbackInfo';

import 'react-loading-skeleton/dist/skeleton.css';
import CanonicalTags from '../../components/CanonicalTags';
import StoreLocator from '../StoreLocator';
import StoreLocatorDetail from '../StoreLocatorDetail';
import { Helmet } from 'react-helmet';
import HomeSkeleton from '../../components/HomeSkeleton';
import DeleteAccount from '../Profile/DeleteAccount';
import DeleteAccountFeedback from '../Profile/DeleteAccountFeedback';
import AccountDeleted from '../Profile/AccountDeleted';
import DeleteAccountError from '../Profile/DeleteAccountError';
import IFrame from '../iFrame/IFrame';
import LightningPayProcessing from '../Checkout/LightningPayProcessing';
import FetchValues from '../../components/Header/FetchValues';

const { fetchStore } = Slices.storeSlice;

const localizePath = (path, locale) => {
  const isLocalized = path.match(/^\/?en\//) || path.match(/^\/?ar\//);
  let localizedPath = path;
  if (!isLocalized) {
    const lang = locale.split('-')[0];
    const hasLeadingSlash = path.match(/^\//);
    const localeFragment = `/${lang}${hasLeadingSlash ? '' : '/'}`;

    localizedPath = `${localeFragment}${path}`;
  }

  return localizedPath;
};

function App() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const selectDefaultValue = getDefaultCountryValues();
  const configStatus = useSelector(selectConfigStatus);
  const menuStatus = useSelector(selectMenuStatus);
  const clusterId = useSelector(getClusterId);
  // const tempCart = useSelector((state) => state.tempCart);
  const auth = useSelector((state) => state.auth);
  const profile = useSelector((state) => state.profile);
  const currentCountry = useSelector(selectCurrentCountry);
  const blobURL = useSelector(getHomeJsonComponents);
  // const cartId = useSelector(selectAuthId);
  // const productsMap = useSelector(selectProductEntities);
  const store = useSelector((state) => state.store);
  const countryPopup = useSelector(getCountryPopState);
  const user = useSelector(selectLoginStatus);
  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, currentCountry)
  );
  const currentProfile = useSelector(getCurrentProfile);
  const isMultiCountryProfile = useSelector(isMultiCountry);
  // const loginQR = useSelector(getQRValue);
  const [menuError, setMenuError] = React.useState(false);
  const [refreshProfile, setRefreshProfile] = React.useState(Cookies.get('Profile'));
  const [foodInstr, setFoodInstr] = React.useState('');
  const context = useContext(Context);
  const [isLoadApp, setIsLoadApp] = useState(false);
  const theme = useTheme();
  // MUI 4 works weirdly for breakpoint helpers, hence changing the breakpoints here. It is fixed in v5.
  // Please see the below link for details
  // https://github.com/mui/material-ui/issues/13448
  // TODO: Uncomment the below lines when you updrade to MUI v5
  // const responsive = {
  //   isMobile: useMediaQuery(theme.breakpoints.down('md')),
  //   isTablet: useMediaQuery(theme.breakpoints.between('md', 'lg')),
  //   isDesktop: useMediaQuery(theme.breakpoints.up('lg')),
  // };

  useEffect(() => {
    if (
      menuStatus === 'succeeded' &&
      configStatus === 'succeeded' // &&
      // profile.status === 'succeeded'
    ) {
      setTimeout(() => {
        setIsLoadApp(true);
      }, 1000);
    }
  }, [menuStatus, configStatus /*, profileStatus */]);

  const responsive = {
    isMobile: useMediaQuery(theme.breakpoints.down('sm')),
    isTablet: useMediaQuery(theme.breakpoints.between('md', 'md')),
    isDesktop: useMediaQuery(theme.breakpoints.up('lg')),
  };

  useEffect(() => {
    if (!Cookies.get('local')) {
      Cookies.set('local', context.locale, { expires: 365 });
    }

    const urlLang = window.location.pathname.split('/')[1];
    const lang = context.locale;
    if (urlLang !== lang) {
      context.selectLanguage(urlLang);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.locale, window.location.pathname]);

  useEffect(() => {
    window.removeEventListener('appinstalled', handleAppInstalled);
    window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  const handleBeforeInstallPrompt = (event) => {
    beforeInstallPromptPwaGA();
  };
  const handleAppInstalled = (event) => {
    installPwaGA();
  };
  useEffect(() => {
    return globalHistory.listen(async (params) => {
      if (auth.status === 'succeeded') {
        const href = params.location.href;
        const path = params.location.pathname;
        virtualPageGA(href, path, user);
        const localProfile = JSON.parse(window.localStorage.getItem('profileDraft'));
        const defaultPro = {
          draft: { ...localProfile },
        };
        userIDGA(user, defaultPro, window.location.pathname);
        deliveryModeGA();
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.status, user]);
  useEffect(() => {
    if (responsive.isMobile || responsive.isTablet || responsive.isDesktop) {
      dispatch(setResponsive(responsive));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responsive.isMobile, responsive.isTablet, responsive.isDesktop]);

  useEffect(() => {
    try {
      const pro = Cookies.get('Profile');
      if (pro === 'true') {
        Cookies.set('Profile', false, { expires: 365 });
        setRefreshProfile(false);
      }
    } catch (err) {
      console.log(err);
      setIsLoadApp(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshProfile]);

  const orderModes = useSelector((state) => selectOrderModesByCountry(state, currentCountry));
  useEffect(() => {
    try {
      if (configStatus === 'succeeded') {
        const addressToken = window.localStorage.getItem('_add');
        const selectedOrderMode = orderModes.filter(
          (orderMode) => orderMode.type == JSON.parse(addressToken)?.addressSubType
        );

        if (auth.isLoggedIn || auth.guestLogin) {
          if (addressToken && selectedOrderMode[0]?.enable) {
            dispatch(saveAddressToDefault(JSON.parse(addressToken)));
          } else {
            window.localStorage.removeItem('_add');
          }
        }
      }
    } catch (err) {
      console.log(err);
      setIsLoadApp(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isLoggedIn, auth.guestLogin]);
  useEffect(() => {
    try {
      if (configStatus === 'succeeded' && profile.country) {
        let goGreenOptions = countryValidations.goGreenConfig.GO_GREEN_OPTIONS.map((val) => {
          return { ...val, status: 0, ENABLE: 0 };
        });
        dispatch(saveActGreenValues(goGreenOptions));
      }
    } catch (err) {
      console.log(err);
      setIsLoadApp(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configStatus, profile.country]);
  useEffect(() => {
    try {
      if (
        configStatus === 'succeeded' &&
        // profileStatus === 'succeeded' &&
        store.status !== 'failed' &&
        store.status === 'idle'
      ) {
        dispatch(fetchStore({ country: profile.country?.toLowerCase() })).then((res) => {
          setIsLoadApp(true);
        });
      }
    } catch (err) {
      console.log(err);
      setIsLoadApp(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configStatus, store.status, /*profileStatus,*/ profile.country]);
  useEffect(() => {
    try {
      const localProfile = JSON.parse(window.localStorage.getItem('profileDraft'));
      if (
        localProfile?._id &&
        auth.guestLogin === false &&
        auth.isLoggedIn === false &&
        profile.status === 'idle' &&
        configStatus === 'succeeded' &&
        menuStatus === 'succeeded'
      ) {
        const payloadToken = {
          // headers: {
          //   authorization: 'Bearer ',
          // },
        };
        dispatch(getProfile())
          .then((resp) => {
            console.log('resp1 - ', resp);
            if (resp.error) {
              dispatch(setRefreshToken(payloadToken))
                .then((resp2) => {
                  console.log(`resp2 - `, resp2);
                  if (resp2.error && (profile.status == 'idle' || profile.status == 'GetFailed')) {
                    dispatch(loginGuest()).then(() => {
                      // window.location.reload();
                      dispatch(getProfile());
                    });
                  }
                })
                .catch((error) => {
                  dispatch(loginGuest()).then(() => {
                    // window.location.reload();
                    dispatch(getProfile());
                  });
                });
            }
          })
          .catch((e) => console.log(`e profile ==> `, e));
      } else if (
        !localProfile?._id &&
        // !cartId &&
        !auth.guestLogin &&
        !auth.isLoggedIn &&
        auth.status === 'idle'
      ) {
        if (profile.status === 'idle') {
          dispatch(loginGuest());
        }
      }
    } catch (err) {
      console.log(`err p ==>> `, err);
      setIsLoadApp(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    configStatus,
    menuStatus,
    profile.status,
    auth.guestLogin,
    auth.isLoggedIn,
    auth.status,
    profile.status,
    // cartId,
    // productsMap,
  ]);

  const Capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  useEffect(() => {
    try {
      if (configStatus === 'idle') {
        dispatch(fetchConfig())
          .then((resp) => {
            if (!resp.error) {
              const countryName = Cookies.get('country')
                ? Cookies.get('country')
                : selectDefaultValue.defaultCountry.toUpperCase();
              if (!Cookies.get('country')) {
                Cookies.set('country', selectDefaultValue.defaultCountry.toUpperCase(), {
                  expires: 365,
                });
              }
              const lang = Cookies.get('local')
                ? Cookies.get('local')
                : selectDefaultValue.defaultLang;
              const isExist = resp?.payload?.data?.data?.contrySpecificValidation.findIndex(
                ({ country }) => country === countryName
              );
              const addressObj = window.localStorage.getItem('_add')
                ? JSON.parse(window.localStorage.getItem('_add'))
                : '';
              const payload = {
                blob: resp.payload.data.data.blobBaseUrl,
                country: countryName.toUpperCase(),
                brand: selectDefaultValue.brand,
                menu:
                  addressObj?.menuTemplateId ||
                  resp?.payload?.data?.data?.contrySpecificValidation[isExist].defaultMenuTempId,
                defMenu:
                  addressObj?.menuId ||
                  resp.payload?.data?.data?.contrySpecificValidation[isExist].defaultMenuId,
                lang: Capitalize(lang),
                cluster: clusterId,
              };
              dispatch(fetchMenu(payload))
                .then((menuResp) => {
                  if (!menuResp.error) {
                    setMenuError(false);
                  } else {
                    setMenuError(true);
                    setIsLoadApp(true);
                  }
                })
                .catch((err) => {
                  setMenuError(true);
                  setIsLoadApp(true);
                });
            } else {
              setMenuError(true);
              setIsLoadApp(true);
            }
            const PagePath = window.location.pathname;
            const hrefPath = window.location.href;
            virtualPageGA(hrefPath, PagePath, user);
          })
          .catch((err) => {
            console.log(err);
            setIsLoadApp(false);
          });
      }
    } catch (err) {
      console.log(err);
      setIsLoadApp(false);
    }
  }, [
    blobURL,
    configStatus,
    dispatch,
    menuStatus,
    user,
    currentCountry,
    selectDefaultValue.defaultCountry,
    selectDefaultValue.defaultLang,
    selectDefaultValue.brand,
    clusterId,
  ]);

  useEffect(() => {
    return globalHistory.listen(async (params) => {
      window.dataLayer.push({
        event: 'page_view',
        url: window.location.pathname,
      });
      // TODO: This is a great place to track Page Views in GA
      window.scrollTo(0, 0);
      const localizedPath = localizePath(params.location.pathname, intl.locale);
      if (params.action === 'PUSH' && localizedPath !== params.location.pathname) {
        await navigate(localizedPath, { replace: true });
      }
    });
  }, [intl.locale]);
  //const NotFound = () => <p>Sorry, nothing here</p>;
  useEffect(() => {
    try {
      if (auth.isLoggedIn) {
        dispatch(fetchAddress()).then((resp) => {});
      }
    } catch (err) {
      console.log(err);
      setIsLoadApp(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isLoggedIn]);
  const changeFoodInstr = (e) => {
    setFoodInstr(e.target.value);
  };
  //
  // TODO: fix the router to have more strict locale routes

  function Routes(props) {
    return (
      <Router {...props} basepath={`/:locale`}>
        <Home path="/home" default />
        <Login path="/login" />
        <AboutPage path="/aboutUs" />
        <GuestOTP path="/verifyOTPGuest" />
        <Home path="/pickupHome" />
        <VerifyOTP path="/verifyOTP" />
        <Cart path="/cart" foodInstr={foodInstr} handleFoodInstr={changeFoodInstr} />
        <FAQ path="/faq" />
        <Terms path="/terms" />
        {/* <LocalChicken path="local-chicken" /> */}
        <OfferApplied path="/offer-applied" />
        <Checkout path="/checkout" foodInstr={foodInstr} handleFoodInstr={changeFoodInstr} />
        <AddAddress path="/addAddress" />
        <AddAddress path="/addAddress/:action" />
        <AddAddress path="/addaddress" />
        <AddAddress path="/addaddress/:action" />
        <EditAddress path="/editAddress/:addressId" />
        <Offers path="/offers" />
        <Offers path="/offers/:action" />
        <Profile path="/profile" />
        <Payment path="/payment" />
        <Guest path="/guest" />
        <StoreLocator path="/storelocator" />
        <StoreLocatorDetail path="/store/:storeSlug/:storeId" />
        <AddEmail path="/email-otp" />
        <MySavedCards path="/my-cards" />
        <DeleteAccount path="/delete-account" />
        <DeleteAccountFeedback path="/delete-account/feedback" />
        <DeleteAccountError path="/delete-account/fail" />
        <AccountDeleted path="/delete-account/success" />
        <Addresses path="/addresses" />
        <AddressList path="/delivery" isDesktop={responsive.isDesktop} />
        <AddressList path="/delivery/:action" />
        <AddressList path="/addresses/:action" />
        <Category path="/favorites" />
        <AddNumber path="/addNumber" />
        <AddNumberVerifyOTP path="/numberOtp" />
        <OrderHistoryList path="/order-history" />
        <Thankyou path="/orderstatus" />
        <Thankyou path="/thank-you/:orderId" />
        <Pickup path="/pickup" />
        <Pickup path="/pickup/:action" />
        <Pickup path="/store" />
        <LightningPayProcessing path="/checkout/lightning-pay" />
        <Carhop path="/carhop" />
        <Carhop path="/carhop/:action" />
        <DineIn path="/dinein" />
        <DineIn path="/dinein/:action" />
        <DriveThru path="/drivethru" />
        <DriveThru path="/drivethru/:action" />
        <OrderDetail path="/order-detail/:orderId" />
        <TrackOrderDetail path="/track-order/:orderId" />
        <OrderHistoryList path="/track-order" />
        <IFrame path="/orderInvoice" />
        <Feedback path="/feedback" />
        <FeedbackInfo path="/feedback/sent" />
        <Deal path="/:encodedCategoryName/:categoryID/:encodedProductName/:productID/bundle" />
        <Product path="/:encodedCategoryName/:categoryID/:encodedProductName/:productID" />
        <Category path="/:encodedCategoryName/:categoryID" />
        <Customize path="/customize/:encodedProductName/:productID/:cartID" />
        <CreateProfile path="/create-profile" />
        <Logout path="/logout" />
        <Search path="/search" />
        <NutritionInfo path="/nutritionInfo" />
        <PrivacyPolicy path="/privacyPolicy" />
        <ContactUs path="/contactUs" />
        <Redirect from="/" to="/en/home" noThrow />

        {/* <NotFound default locale={'locale'} /> */}
      </Router>
    );
  }
  const handleClose = (location, oldLocation) => () => {
    if (oldLocation?.pathname !== '') {
      const current = location.pathname.split('/');
      if (current[2] === 'create-profile') {
        if (!isMultiCountryProfile) {
          dispatch(logout()).then((respBack) => {
            dispatch(loginGuest());
          });

          navigate(oldLocation ? oldLocation.href : location.href, { replace: true });
        } else {
          navigate(oldLocation ? oldLocation.href : location.href, { replace: true });
        }
      } else if (current[2] === 'guest') {
        navigate(`/${context.locale}/cart`);
      } else {
        navigate(oldLocation ? oldLocation.href : location.href, { replace: true });
      }
    } else {
      navigate('/');
    }
  };

  const loadDataLayer = () => {
    return (
      <>
        <Helmet>
          <script>
            {`(function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
    'gtm.start':
    new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${
      process.env[`REACT_APP_GTM_${selectDefaultValue.defaultCountry.toUpperCase()}`]
    }');`}
          </script>
        </Helmet>
      </>
    );
  };

  return (
    <>
      {loadDataLayer()}
      <Location>
        {({ location }) => {
          const current = location.pathname.split('/');
          const pathMatch = [
            'login',
            'addresses',
            'verifyOTP',
            'order-history',
            'verifyOTPGuest',
            'order-detail',
            'editAddress',
            'my-cards',
            'guest',
            'customize',
            'addAddress',
            'carhop',
            'email-otp',
            'create-profile',
            'feedback',
            'offers',
            'delivery',
            'store',
            'dinein',
            'drivethru',
            'profile',
            'addaddress',
            'track-order',
            'create-profile',
          ];
          const check = pathMatch.find((val) => val === current[2]);

          let { oldLocation, titleId, description = '' } = location.state || {};
          let loadDig = responsive.isDesktop;

          if (check && !oldLocation && responsive.isDesktop) {
            if (check !== 'store' && current.length < 4) {
              loadDig = true;
              oldLocation = { ...location, href: location.origin, pathname: '' };
            }
          }

          if (location.pathname.includes('bundle')) {
            loadDig = false;
          }

          if (location.pathname === '/') {
            navigate(`/${context.locale}/home`);
          }
          if (!isLoadApp) {
            return <HomeSkeleton isShowHeader />;
          } else {
            return (
              <>
                <div className={css.iosOverscrollFix}></div>
                <FetchValues />
                <MultiCountryPopUp open={countryPopup}>
                  <SwipeableCountryDrawer />
                </MultiCountryPopUp>
                {/* {menuError ? (
                  <div className={css.error}>
                    <div className={css.child}>
                      Error! Something went wrong please{' '}
                      <a href="/" onClick={refreshPage}>
                        Refresh
                      </a>
                    </div>
                  </div>
                ) : (
                  ''
                )} */}
                <Routes
                  location={oldLocation != null && loadDig ? oldLocation : location}
                  className={css.pageWrapper}
                />
                <CanonicalTags />
                {current[2] === 'offers' && loadDig ? (
                  <Drawer
                    anchor={
                      location?.state?.mode
                        ? location.state.mode
                        : context.locale === 'en'
                        ? 'left'
                        : 'right'
                    }
                    open={oldLocation != null && loadDig}
                    onClose={handleClose(location, oldLocation)}
                    className={css.zIndx}
                  >
                    <Routes location={location} />
                  </Drawer>
                ) : (
                  <DialogBox
                    isOpen={oldLocation != null && loadDig}
                    titleId={titleId || ''}
                    description={description}
                    hideCloseButton={true}
                    onClose={handleClose(location, oldLocation)}
                  >
                    <Routes location={location} />
                  </DialogBox>
                )}
              </>
            );
          }
        }}
      </Location>
    </>
  );
}

export default App;
